<script>
import TopoMapEditor from './topo-map.vue';

// the topographic editor with building plies instead of terrain, opening on a whole city centre
export default {
    name: 'CityMapEditor',
    extends: TopoMapEditor,
    data() {
        return {
            editorType: 'city-map',
            mapCenter: { lat: 47.4979, lng: 19.0402 },
            zoomLevel: 14.5,
            selectedOptions: {
                mode: 'city',
                title: { value: 'Budapest' },
                locationLatLong: '47.4979, 19.0402',
                zoomLevel: 14.5,
            },
        };
    },
};
</script>
